import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { PlusIcon } from 'lucide-react';
import { BUSINESSES, CATEGORIES } from '../data';
import { useCart } from '../CartContext';
import { Reveal } from '../components/Reveal';
export function Marketplace() {
  const location = useLocation();
  const {
    addToCart
  } = useCart();
  const [activeCategory, setActiveCategory] = useState<string>('Alla');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  // Flatten all products from all businesses
  const allProducts = BUSINESSES.flatMap(b => b.products);

  // Get unique categories that actually have products
  const activeCategories = ['Alla', ...Array.from(new Set(allProducts.map(p => p.category)))];
  const filteredProducts = activeCategory === 'Alla' ? allProducts : allProducts.filter(p => p.category === activeCategory);
  return <div className="min-h-screen bg-warm pt-32 pb-20" data-id="element-354" data-mp="272xo8ajm7t5p">
      <div className="mx-auto max-w-7xl px-6 md:px-10" data-id="element-355" data-mp="271cp07mcvm1i">
        <Reveal data-id="element-356" data-mp="1elgouqe2qofm">
          <h1 className="font-display text-5xl font-light text-brun md:text-7xl" data-id="element-357" data-mp="1em07k9bjtgup">Vårt utbud</h1>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-brun-soft" data-id="element-358" data-mp="19k15d2rjopzc">
            Utforska Smålands bästa smaker. Filtrera på kategori eller bläddra fritt bland våra partners handplockade sortiment.
          </p>
        </Reveal>

        {/* Category Filter */}
        <Reveal delay={0.1} data-id="element-359" data-mp="1xa552z1m45l2">
          <div className="mt-12 flex flex-wrap gap-2 border-b border-brun/10 pb-8" data-id="element-360" data-mp="1xaew8pye8isc">
            {activeCategories.map(cat => <button key={cat} onClick={() => setActiveCategory(cat)} className={`rounded-full px-5 py-2 text-sm transition-colors ${activeCategory === cat ? 'bg-skog text-warm' : 'border border-brun/20 text-brun hover:border-brun/50'}`} data-id="element-361" data-mp="1nldiz7j8gfi2">
                {cat}
              </button>)}
          </div>
        </Reveal>

        {/* Product Grid */}
        <div className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4" data-id="element-362" data-mp="ecim95z3ntzi">
          {filteredProducts.map((product, i) => <Reveal key={product.id} delay={Math.min(i * 0.05, 0.5)} data-id="element-363" data-mp="3vryybpzhbh1p" data-mpi={i}>
              <div className="group flex h-full flex-col overflow-hidden rounded-sm border border-brun/10 bg-beige transition-colors hover:border-brun/30" data-id="element-364" data-mp="4mfiqbucqxmx">
                <div className="relative h-56 overflow-hidden" data-id="element-365" data-mp="3mr0pmue3ilcs">
                  <img src={product.image} alt={product.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-366" data-mp="3quynz2vljs4s" />
                  <div className="absolute left-3 top-3 rounded-full bg-warm/90 px-3 py-1 text-[10px] uppercase tracking-wide2 text-brun backdrop-blur-sm" data-id="element-367" data-mp="3ht7l05sfxzem">
                    {product.category}
                  </div>
                </div>
                <div className="flex flex-1 flex-col p-5" data-id="element-368" data-mp="1g0t6zht0pf3h">
                  <Link to={`/partner/${product.businessSlug}`} className="text-[11px] uppercase tracking-wide2 text-terrakotta hover:text-skog" data-id="element-369" data-mp="30jwn5jno6ga4">
                    {product.businessName}
                  </Link>
                  <h3 className="mt-2 font-display text-xl text-brun" data-id="element-370" data-mp="3aa82e2ct0bwb">{product.name}</h3>
                  
                  <div className="mt-auto pt-6" data-id="element-371" data-mp="35igczv5dwc7r">
                    <button onClick={() => addToCart(product)} className="flex w-full items-center justify-center gap-2 rounded-sm bg-skog/10 py-3 text-sm font-medium text-skog transition-colors hover:bg-skog hover:text-warm" data-id="element-372" data-mp="35gwsfscp3f06">
                      <PlusIcon className="h-4 w-4" data-id="element-373" data-mp="3t7sr99fkjagx" />
                      Lägg till i förfrågan
                    </button>
                  </div>
                </div>
              </div>
            </Reveal>)}
        </div>
      </div>
    </div>;
}